import { useEffect, useState } from "react";
import { getPresentacion, actualizarImagen } from "../componentes/api.js";
import { Alert, AlertTitle, Divider } from "@mui/material";
import ReactPlayer from "react-player";
import { RUTA_IMG } from "../componentes/config";
import Spinner from "react-bootstrap/Spinner";
import { sqlAdjunto } from "../componentes/api.js";

function Presentacion(props) {
  const [actualizando, setActualizando] = useState(false);
  /** Para muestra apreliminar de videos */
  const [file, setFile] = useState(null);
  const [video, setVideo] = useState(null);

  const handleChange = (e) => {
    setFile(e.files[0]);
    setVideo(URL.createObjectURL(e.files[0]));
  };

  const grabar = async (event) => {
    event.preventDefault();
    setActualizando(true);
    if (props.Id === "") {
      setActualizando(false);
      props.mostrarMsg(["Por favor seleccione un Proyecto"]);
    } else if (file === null) {
      setActualizando(false);
      props.mostrarMsg(["Por favor seleccione un archivo para subir"]);
    } else {
      try {
        /** Formateo los datos que enviaré */
        const formData = new FormData();
        formData.append("Ruta", props.Ruta);
        formData.append("Tabla", props.Tabla);
        formData.append("Campo", props.Campo);
        formData.append("Id", props.Id);
        formData.append("UsuarioReg", props.UsuarioReg);
        formData.append("Img", props.Img);
        formData.append("image", file);

        const response = await sqlAdjunto("setImagen", formData);
        setActualizando(false);
        props.mostrarMsg(["Felicidades!!", "Presentación actualizada"]);
      } catch (error) {
        setActualizando(false);
        alert(
          "ERROR",
          "Ocurrio un error al Grabar la Presentación del Proyecto",
          error
        );
      }
    }
  };

  useEffect(() => {
    const traerPresentacion = async () => {
      try {
        setActualizando(true);
        const response = await getPresentacion({ idProyecto: props.Id });
        setVideo(
          RUTA_IMG + "proyectos/presentacion/" + response.data.Presentacion
        );
        setActualizando(false);
      } catch (error) {
        setActualizando(false);
        props.mostrarMsg([
          "ERROR",
          "Ocurrio un error al cargar el combo de participantes",
          error,
        ]);
      }
    };

    if (props.Id !== "") {
      traerPresentacion();
    }
  }, [props.Id]);

  return (
    <div className="container-fluid mt-2 mb-3">
      <div className="row card">
        <Alert severity="success">
          <AlertTitle>
            <strong>Video de Presentación del Proyecto</strong>
          </AlertTitle>
          Por favor seleccione un archivo para subir al servidor!.
        </Alert>

        <div className="mt-3 mb-3 text-center">
          <div className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url={video}
              width="100%"
              height="100%"
              controls={true}
            />
          </div>
        </div>

        <div className="row mb-3">
          {actualizando === true && (
            <div>
              <Spinner
                animation="grow"
                variant="primary"
                size="xl"
                role="status"
              ></Spinner>
              <span className="visually">
                Un momento por favor, estamos actualizando la Presentación...
              </span>
            </div>
          )}
          <form method="post" encType="multipart/form-data">
            <input
              className="form-control"
              type="file"
              name="archivo"
              id="archivo"
              //accept={datosAnexo.formato}
              onChange={(e) => handleChange(e.target)} //multiple
            />
            <Divider light className="mt-1 mb-1" />
            <button
              className="btn btn-primary"
              onClick={(event) => grabar(event)}
            >
              Subir video al servidor
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
export default Presentacion;
